module.exports = __webpack_public_path__ + "static/media/tombstone.b7e8d642.svg";